

import { Component, Vue, Prop } from "vue-property-decorator"

import { Feature } from "@/types/tenant"

@Component({
	components: {
	}
})
export default class TenantFeatures extends Vue {
	@Prop({ default: [] })
	features!: Feature[]

	@Prop({ default: () => {} })
	value!: { [key: string]: boolean }

	get options () {
		return this.features.map(feature => {
			return {
				text: feature.title,
				value: feature.key
			}
		})
	}

	get enabledFeatures (): string[] {
		return Object.keys(this.value).filter(f => this.value[f])
	}

	featuresChanged (updatedList: string[]) {
		const updatedListItems = updatedList.filter(f => this.options.some(o => o.value === f))

		const oldValue = Object.keys(this.value).filter(f => this.value[f])
		const newValue = updatedListItems.reduce((p, c) => {
			p[c] = true
			return p
		}, {} as { [key: string]: boolean })

		if (oldValue.length !== updatedListItems.length || oldValue.some(o => !updatedListItems.includes(o))) {
			this.$emit("input", newValue)
		}
	}
}
